import React from 'react';
import Modal from 'chameleon/ui-stack/ui/base/modal';

import './index.scss';

const AssessmentsModal = (props) => {
  const { isOpen, setIsOpen, assessmentsPopOverData } = props;
  const { labelDescription, assessmentsScoreData } = assessmentsPopOverData;
  const getBarColor = (percentage) => {
    let barColor;
    if (!percentage) {
      barColor = '#fedb00';
    } else if (percentage <= 24.99) {
      barColor = '#fedb00';
    } else if (percentage <= 49.99) {
      barColor = '#ffec9c';
    } else if (percentage <= 74.99) {
      barColor = '#bff5aa';
    } else if (percentage <= 100) {
      barColor = '#6cc24a';
    }
    return barColor;
  };

  const renderAssessmentScoreData = () =>
    assessmentsScoreData.map(({ score, title, date }) => (
      <div className="section-body-row">
        <div className="title">{title}</div>
        <div className="score-date-wrapper">
          <div className="score-with-color">
            <div style={{ backgroundColor: getBarColor(score) }} />
            {score}%
          </div>
          <span>{date}</span>
        </div>
      </div>
    ));

  return (
    isOpen && (
      <div>
        <Modal
          size="full"
          onClose={() => setIsOpen(false)}
          title={labelDescription}
          headingClassName="title-truncate"
          dialogClassName="dialogClassName"
          contentClassName="dialogClassName"
          wrapperClassName="modal-wrapper"
        >
          <div className="grid gap-y-4">
            <section className="section-header">
              <div>ASSIGNMENT</div>
              <div>SCORED</div>
            </section>
            <section className="section-body">
              {renderAssessmentScoreData()}
            </section>
          </div>
        </Modal>
      </div>
    )
  );
};

export default AssessmentsModal;
